import { Pipe, PipeTransform } from '@angular/core';
import parsePhoneNumberFromString, { CountryCode } from 'libphonenumber-js';

@Pipe({
  name: 'phoneFormat',
  standalone: true,
})
export class PhoneFormatPipe implements PipeTransform {
  transform(phone: string, countryCode: string): string {
    if (!phone) {
      return '';
    }
    const parsed = parsePhoneNumberFromString(phone, {
      defaultCountry: countryCode as CountryCode,
    });
    if (!parsed) {
      return phone;
    }
    return parsed.country === countryCode ? parsed.formatNational() : parsed.formatInternational();
  }
}
